import { type FC, useState, useCallback } from 'react';
import styled, { useTheme } from 'styled-components';
import { ValidateOTPCard } from './components/ValidateOTPCard';
import { useZustandStore } from '../../appState/StoresProvider';
import { useOtpRequestExpiryHandling } from './hooks/useOtpRequestExpiryHandling';
import { Spinner } from '../Spinner/Spinner';
import { useAuthStore } from '../Login/useAuthStore';

export const OneTimePassword: FC = () => {
  const resetOtpRequestInfo = useAuthStore((state) => state.resetOtpRequestInfo);
  const requestOTP = useAuthStore((state) => state.requestOTP);
  const signInWithOTP = useAuthStore((state) => state.signInWithOTP);
  const waiting = useZustandStore('auth', (v) => v.isFetching);
  const [error, setError] = useState<string | undefined>(undefined);
  const [buttonDisabled, _setButtonDisabled] = useState<boolean | undefined>(undefined);

  const otpRequestInfo = useOtpRequestInfo();
  const { normalizedTimeToExpiry, canResend } = useOtpRequestExpiryHandling();

  const handleBack = useCallback(() => {
    resetOtpRequestInfo();
  }, [resetOtpRequestInfo]);

  const handleResend = useCallback(() => {
    if (otpRequestInfo == null) {
      return;
    }
    setError(undefined);
    requestOTP(otpRequestInfo.username).then((_status) => {
      // if (!status.success) {
      //   setError(status.error);
      // }
    });
  }, [otpRequestInfo, requestOTP]);

  const handeSubmit = useCallback(
    (code: string) => {
      signInWithOTP(code).then((_status) => {
        // if (!status.success) {
        //   if (status.code === 429) {
        //     setButtonDisabled(true);
        //     setTimeout(() => {
        //       setButtonDisabled(false);
        //     }, 10_000);
        //   }
        //   setError(status.error);
        // }
      });
    },
    [signInWithOTP],
  );
  const theme = useTheme();

  return (
    <OTPContainer>
      {otpRequestInfo ? (
        <ValidateOTPCard
          email={otpRequestInfo.username}
          normalizedTimeToExpiry={normalizedTimeToExpiry}
          canResend={canResend}
          handleBack={handleBack}
          handleResend={handleResend}
          handleSubmit={handeSubmit}
          waiting={waiting}
          errorText={error}
          buttonDisabled={buttonDisabled}
        />
      ) : (
        <Spinner color={theme.colors.primary} size="48px" />
      )}
    </OTPContainer>
  );
};

const OTPContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  background: ${({ theme }) => theme.colors.pageBackground};
`;
function useOtpRequestInfo() {
  const otpRequestInfo = useAuthStore((state) => state.otpRequestInfo);

  // if (otpRequestInfo == null) {
  //   throw Error('No OTP request info available. This is unexpected');
  // }
  return otpRequestInfo;
}
